var _rect, _rect2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDisplayImage(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 127,
    viewBox: "0 0 123 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.49976,
    y: 1.82227,
    width: 123,
    height: 123,
    rx: 61.5,
    fill: "#F6F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1.49976,
    y: 1.82227,
    width: 123,
    height: 123,
    rx: 61.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4191 51.6105C42.4191 61.3028 50.3056 69.184 60.0003 69.184C69.6949 69.184 77.5814 61.3028 77.5814 51.6105C77.5814 41.9182 69.6949 34.0369 60.0003 34.0369C50.3056 34.0369 42.4191 41.9182 42.4191 51.6105ZM60.0003 65.2689C52.4661 65.2689 46.3343 59.1387 46.3343 51.6105C46.3343 44.0822 52.4661 37.952 60.0003 37.952C67.5345 37.952 73.6663 44.0822 73.6663 51.6105C73.6663 59.1387 67.5345 65.2689 60.0003 65.2689Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.784 101.738C32.6952 102.81 31.757 103.61 30.6829 103.528C29.605 103.445 28.7984 102.504 28.8813 101.426C28.8814 101.425 28.8815 101.424 28.8816 101.422C28.8828 101.405 28.887 101.349 28.8955 101.279C30.4226 85.4492 43.7651 73.0771 60.0003 73.0771C76.2474 73.0771 89.5952 85.4655 91.1104 101.312C91.2133 102.388 90.4243 103.344 89.348 103.447C88.2718 103.549 87.3159 102.76 87.213 101.684C85.8882 87.8287 74.2114 76.9922 60.0003 76.9922C45.789 76.9922 34.1106 87.8307 32.7896 101.686C32.788 101.703 32.7861 101.72 32.784 101.738Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8874 31.3097C97.8874 32.3878 97.0129 33.2617 95.9344 33.2617C94.856 33.2617 93.9815 32.3878 93.9815 31.3097C93.9815 30.2316 94.856 29.3577 95.9344 29.3577C97.0129 29.3577 97.8874 30.2316 97.8874 31.3097Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6529 103.055C38.0659 109.484 48.5872 113.299 60.0002 113.299C71.4154 113.299 81.9368 109.484 90.3501 103.055C90.3711 103.039 90.3918 103.023 90.412 103.006C102.323 93.8801 110 79.5043 110 63.3225C110 53.8318 107.358 44.9575 102.767 37.4002C102.206 36.4762 101.002 36.1821 100.078 36.7435C99.1539 37.3048 98.8599 38.5089 99.4213 39.4329C103.65 46.3941 106.085 54.5678 106.085 63.3225C106.085 78.2625 98.99 91.5286 87.9735 99.942C87.953 99.9576 87.933 99.9735 87.9133 99.9898C80.1701 105.886 70.5014 109.384 60.0002 109.384C49.4741 109.384 39.7825 105.868 32.0295 99.9442C21.0127 91.5307 13.9154 78.2643 13.9154 63.3225C13.9154 37.865 34.5244 17.2608 60.0002 17.2608C70.6577 17.2608 80.4591 20.8647 88.2601 26.9214C89.1141 27.5844 90.3438 27.4297 91.0068 26.5757C91.6699 25.7217 91.5151 24.492 90.6611 23.829C82.1964 17.257 71.556 13.3457 60.0002 13.3457C32.3638 13.3457 10.0002 35.7012 10.0002 63.3225C10.0002 79.5344 17.7068 93.9321 29.6529 103.055Z",
    fill: "#E1E1E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDisplayImage);
export default __webpack_public_path__ + "static/media/EmptyDisplayImage.8eedfb0d91ce91a302d4fc6950d86675.svg";
export { ForwardRef as ReactComponent };